/* eslint-disable no-unused-expressions */
const inlineManualShutdown = () => {
  if (window?.InlineManual) {
    window?.InlineManual("shutdown");
  }
};

export default inlineManualShutdown;
